<template>
  <div class="glass-wrapper">

    <div class="glass-card">

      <div class="text-center mb-4">
        <img v-if="header && header.logo" :src="header.logo" style="width: 100%; height: auto; border-radius: 10px; margin-bottom: 20px;">

        <h1 class="fw-bold fw-w" v-if="header.title" v-html="header.title"></h1>
        <p class="disclame" v-if="header.subtitle" v-html="header.subtitle"></p>
      </div>

      <DynamicForm
        :schema="schema"
        :layout="layout"
        @submitted="$emit('submitted', $event)"
      />

    </div>

  </div>
</template>

<script>
import DynamicForm from '@/components/DynamicForm'

export default {
  props: ['theme', 'header', 'schema', 'layout'],
  components: { DynamicForm }
}
</script>

<style scoped>
.glass-wrapper {
  min-height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;
}

.glass-card {
  width: 600px;
  backdrop-filter: blur(20px);
  background: rgba(255,255,255,0.1);
  padding: 50px;
  border-radius: 20px;
  box-shadow: 0 25px 60px rgba(0,0,0,0.4);
}
.fw-w{
  font-size: 20px!important;
  color: #b3863b;
  border-bottom: 1px solid #b3863b;
  margin-bottom: 5px;
}
</style>
